module.exports = __webpack_public_path__ + "reversesmile.0bcca3b5.png";